import React from "react";
import MatchKeysBlock from "./MatchKeysBlock";

export default function TolerancesBlock({ rule, index, onChange }) {
  return (
    <div style={{ marginBottom: "1rem", padding: "0.75rem", background: "#FFFBEB", border: "1px solid #FDE68A", borderRadius: "0.5rem" }}>
      <MatchKeysBlock rule={rule} index={index} onChange={onChange}
        listKey="tolerance_keys" label="Value columns with ± tolerance"
        testidPrefix="tol" addLabel="Add value pair" />
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginTop: "0.5rem" }}>
        <div>
          <label style={{ fontSize: "0.7rem", color: "#92400E", display: "block", marginBottom: "0.2rem" }}>Tolerance Type</label>
          <select data-testid={`tol-type-${index}`} className="recon-input" style={{ fontSize: "0.8rem", width: "100%" }} value={rule.tolerance_type || "absolute"} onChange={e => onChange({ ...rule, tolerance_type: e.target.value })}>
            <option value="absolute">Absolute (±X)</option>
            <option value="percentage">Percentage (±X%)</option>
          </select>
        </div>
        <div>
          <label style={{ fontSize: "0.7rem", color: "#92400E", display: "block", marginBottom: "0.2rem" }}>Tolerance Value</label>
          <input data-testid={`tol-value-${index}`} type="number" step="0.01" className="recon-input" style={{ fontSize: "0.8rem", width: "100%" }} value={rule.tolerance_value ?? 0} onChange={e => onChange({ ...rule, tolerance_value: parseFloat(e.target.value) || 0 })} />
        </div>
      </div>
    </div>
  );
}
